import {
  BaseSortOption,
  ReadonlySortOption,
  SortControlsProps,
} from "modules/common/components/mainbar/types";
import { SortSelect } from "modules/common/components/mainbar/SortSelect";
import { OrderSelect } from "modules/common/components/mainbar/OrderSelect";

export function SortControls<
  T extends BaseSortOption | ReadonlySortOption<any>,
>({
  options,
  currentSort,
  currentOrder,
  onSortChange,
  onOrderChange,
  className,
  classNameOrder,
  classNameSort,
  variant,
  color,
  size,
}: SortControlsProps<T>) {
  const currentSortIndex = options.findIndex((opt) => opt.enum === currentSort);

  return (
    <>
      <SortSelect
        className={classNameSort}
        options={options}
        currentIndex={currentSortIndex}
        onChange={(idx) => onSortChange(options[idx].enum)}
        variant={variant}
        color={color}
        size={size}
      />
      <OrderSelect
        className={classNameOrder}
        currentOrder={currentOrder}
        onChange={onOrderChange}
        variant={variant}
        color={color}
        size={size}
      />
    </>
  );
}
